<template>
  <div class="success-page">
    <div class="success-container">
      <div class="success-card">
        <h1 v-if="isPaymentAwaitingConfirmation">⏳ Payment Submitted!</h1>
        <h1 v-else>🎉 Payment Successful!</h1>
        <p class="success-message" v-if="isPaymentAwaitingConfirmation">
          Your order <strong>#{{ order.number }}</strong> has been received!<br>
          We're verifying your payment. You'll receive a confirmation email once approved.
        </p>
        <p class="success-message" v-else>
          Your order <strong>#{{ order.number }}</strong> has been confirmed!<br>
          We've sent a confirmation email to your inbox.
        </p>
        
        <div class="order-details">
          <div class="detail-row">
            <span>Order Number:</span>
            <span class="order-number">#{{ order.number }}</span>
          </div>
          <div class="detail-row">
            <span>Total Paid:</span>
            <span class="amount">₦{{ formatPrice(order.total) }}</span>
          </div>
          <div class="detail-row">
            <span>Payment Status:</span>
            <span v-if="isPaymentAwaitingConfirmation" class="status awaiting">⏳ Awaiting Confirmation</span>
            <span v-else class="status paid">✓ Paid</span>
          </div>
          <div class="detail-row">
            <span>Order Status:</span>
            <span class="status processing">Processing</span>
          </div>
        </div>

        <div class="content-grid">
          <div class="order-items-summary">
            <h3>Order Summary</h3>
            <div v-for="item in order.order_items" :key="item.id" class="item-row">
              <div class="item-info">
                <p class="item-name">{{ item.product_name }}</p>
                <small>Quantity: {{ item.quantity }}</small>
              </div>
              <span class="item-total">₦{{ formatPrice(item.price * item.quantity) }}</span>
            </div>
            
            <div class="summary-totals">
              <div class="summary-row">
                <span>Subtotal:</span>
                <span>₦{{ formatPrice(order.subtotal || order.total) }}</span>
              </div>
              <div v-if="order.shipping_cost" class="summary-row">
                <span>Shipping:</span>
                <span>₦{{ formatPrice(order.shipping_cost) }}</span>
              </div>
              <div v-if="order.discount_amount" class="summary-row discount">
                <span>Discount:</span>
                <span>-₦{{ formatPrice(order.discount_amount) }}</span>
              </div>
              <div class="summary-row total">
                <span>Total:</span>
                <span>₦{{ formatPrice(order.total) }}</span>
              </div>
            </div>
          </div>

          <div class="shipping-info" v-if="order.shipping">
            <h3>Shipping Address</h3>
            <p v-if="order.shipping.recipient_first_name || order.shipping.recipient_last_name">{{ order.shipping.recipient_first_name }} {{ order.shipping.recipient_last_name }}</p>
            <p>{{ order.shipping.address }}</p>
            <p>{{ order.shipping.city }}<span v-if="order.shipping.state">, {{ order.shipping.state.name }}</span> {{ order.shipping.zip }}</p>
            
            <div class="actions">
              <a :href="`/orders/${order.number}`" class="btn-view-order">
                <i class="fas fa-eye"></i>
                View Order Details
              </a>
              <a href="/" class="btn-primary">
                <i class="fas fa-shopping-bag"></i>
                Continue Shopping
              </a>
            </div>
          </div>
        </div>

        <p class="thank-you">
          <i class="fas fa-heart"></i>
          Thank you for shopping with us!
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentSuccess',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    isPaymentAwaitingConfirmation() {
      return this.order.payments?.some(p => p.status === 'awaiting_confirmation') || false
    }
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('en-NG').format(price)
    }
  }
}
</script>
